import gsap from '../lib/gsap.min';
import ScrollTrigger from '../lib/ScrollTrigger.min';

export function mosaicFunc() {
	const mosaicParts = document.querySelectorAll('.mosaic_parts');
	if (!mosaicParts.length) return;

	const COLOR = '#4266c9';
  const COLOR2 = '#70c2a3';

	mosaicParts.forEach(part => {
    const isLast = part.classList.contains('last');
		const canvas = part.querySelector('.mosaic_canvas');
		if (!canvas) return;

		const ctx = canvas.getContext('2d');
		if (!ctx) return;

		const offscreenCanvas0 = document.createElement('canvas');
		const offctx0 = offscreenCanvas0.getContext('2d');
		const offscreenCanvas1 = document.createElement('canvas');
		const offctx1 = offscreenCanvas1.getContext('2d');

		let tile_count, dpr, baseWidth, baseHeight, offscreenWidth, COLS;
		let TILE, HALF, CUTOUT_RADIUS, CIRCLE_RADIUS, moveDistance, PAD_Y, TOP_ROW_Y, BOTTOM_ROW_Y;

		const drawBoxShape = (ctx, x, y) => {
			const prevComposite = ctx.globalCompositeOperation;
			ctx.beginPath();
			ctx.rect(x, y, TILE, TILE);
			ctx.fill();

			ctx.globalCompositeOperation = 'destination-out';
			ctx.beginPath();
			ctx.arc(x + HALF, y + HALF, CUTOUT_RADIUS, 0, Math.PI * 2);
			ctx.fill();
			ctx.globalCompositeOperation = prevComposite;
		};

		const drawCircleShape = (ctx, x, y, ox, oy) => {
			ctx.beginPath();
			ctx.arc(x + ox, y + HALF + oy, CIRCLE_RADIUS, 0, Math.PI * 2);
			ctx.fill();
		};

		const setup = () => {
      tile_count = window.innerWidth <= 767 ? 6 : 8;
			dpr          = window.devicePixelRatio || 1;
			baseWidth    = document.documentElement.clientWidth;
			TILE         = Math.round((baseWidth / (tile_count + 1)) / 2) * 2;
			HALF         = TILE / 2;
			CUTOUT_RADIUS = HALF + 0.05;
			CIRCLE_RADIUS = HALF + 0.3;
			moveDistance = Math.round(TILE * 0.3);
			PAD_Y        = isLast ? 0 : moveDistance;
			TOP_ROW_Y    = PAD_Y;
			BOTTOM_ROW_Y = PAD_Y + TILE;
			baseHeight   = TILE * 2 + moveDistance * 2;
			offscreenWidth = baseWidth + TILE;
			COLS         = tile_count/2;

			canvas.width = Math.round(baseWidth * dpr);
			canvas.height = Math.round(baseHeight * dpr);
			ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

			offscreenCanvas0.width = Math.round(offscreenWidth * dpr);
			offscreenCanvas0.height = Math.round(baseHeight * dpr);
			offctx0.setTransform(dpr, 0, 0, dpr, 0, 0);

			offscreenCanvas1.width = Math.round(offscreenWidth * dpr);
			offscreenCanvas1.height = Math.round(baseHeight * dpr);
			offctx1.setTransform(dpr, 0, 0, dpr, 0, 0);
		};

		const render = (progress = 0, circleStates = null) => {
			const startOffsetX = -HALF;
			const hasProgress = circleStates
				? circleStates.some(state => state.progress > 0)
				: progress > 0;

			const getTopColor = i => (i % 2 === 0 ? COLOR : COLOR2);
			const getBottomColor = i => (i % 2 === 0 ? COLOR2 : COLOR);

			const renderSet = (context, offset, colorPhase = 0, colLimit = COLS, layerIndex = 0) => {
				context.clearRect(0, 0, offscreenWidth, baseHeight);
				context.globalCompositeOperation = 'source-over';

				for (let i = 0; i < colLimit; i += 1) {
					const colorIndex = i * 2 + colorPhase;
					context.fillStyle = getTopColor(colorIndex);
					drawBoxShape(context, i * TILE * 2 + offset, TOP_ROW_Y);
					context.fillStyle = getBottomColor(colorIndex);
					drawBoxShape(context, i * TILE * 2 + offset, BOTTOM_ROW_Y);
				}

				const addXorQuadrantRects = () => {
					for (let i = 0; i < colLimit; i += 1) {
						context.rect(i * TILE * 2 + offset + HALF, TOP_ROW_Y,           HALF, HALF);
						context.rect(i * TILE * 2 + offset,        BOTTOM_ROW_Y + HALF, HALF, HALF);
					}
				};

				const drawAllCircles = () => {
					for (let i = 0; i < colLimit; i += 1) {
						const stateBase = layerIndex * COLS * 2 + i * 2;
						const topProgress = circleStates ? (circleStates[stateBase]?.progress ?? 0) : progress;
						const bottomProgress = circleStates ? (circleStates[stateBase + 1]?.progress ?? 0) : progress;
						const circle1Offset = {
							x: startOffsetX + moveDistance * topProgress,
							y: -moveDistance * topProgress,
						};
						const circle2Offset = {
							x: startOffsetX - moveDistance * bottomProgress,
							y: moveDistance * bottomProgress,
						};
						const colorIndex = i * 2 + colorPhase;
						context.fillStyle = getTopColor(colorIndex);
						drawCircleShape(context, i * TILE * 2 + offset + TILE, TOP_ROW_Y,    circle1Offset.x, circle1Offset.y);
						context.fillStyle = getBottomColor(colorIndex);
						drawCircleShape(context, i * TILE * 2 + offset + TILE, BOTTOM_ROW_Y, circle2Offset.x, circle2Offset.y);
					}
				};

				context.save();
				context.beginPath();
				addXorQuadrantRects();
				context.clip();
				context.globalCompositeOperation = hasProgress ? 'xor' : 'source-over';
				drawAllCircles();
				context.restore();

				context.save();
				context.beginPath();
				context.rect(0, 0, offscreenWidth, baseHeight);
				addXorQuadrantRects();
				context.clip('evenodd');
				context.globalCompositeOperation = 'source-over';
				drawAllCircles();
				context.restore();
			};

			ctx.clearRect(0, 0, baseWidth, baseHeight);
			ctx.globalCompositeOperation = 'source-over';

			renderSet(offctx0, TILE, 0, COLS, 0);
			renderSet(offctx1, TILE, 1, COLS, 1);

			ctx.drawImage(offscreenCanvas0, 0, 0, Math.round((baseWidth + HALF) * dpr), Math.round(baseHeight * dpr), -HALF,       0, baseWidth + HALF, baseHeight);
			ctx.drawImage(offscreenCanvas1, 0, 0, Math.round((baseWidth + HALF) * dpr), Math.round(baseHeight * dpr), TILE - HALF, 0, baseWidth + HALF, baseHeight);
		};

		setup();
		render(0);
		let hasPlayed = false;
		let playTween = null;

		ScrollTrigger.create({
			trigger: part,
			start: 'bottom bottom',
			once: true,
			invalidateOnRefresh: true,
			onEnter: () => {
				if (hasPlayed) return;
				hasPlayed = true;
				if (playTween) playTween.kill();
				const circleStates = Array.from({ length: COLS * 4 }, () => ({ progress: 0 }));
				playTween = gsap.to(circleStates, {
					progress: 1,
					duration: 1.4,
					stagger: {
						each: 0.04,
						from: 'random',
					},
					ease: 'power2.inOut',
					onUpdate: () => render(0, circleStates),
					onComplete: () => render(1),
				});
			},
			onRefresh: () => {
				setup();
				render(hasPlayed ? 1 : 0);
			},
		});
	});
}
